/**
 * Deterministic color palette for chart metrics.
 * Each metric name maps to a consistent color via simple hashing.
 */

const CHART_PALETTE = [
  '#1A64B1', // blue
  '#2E8B57', // sea green
  '#7B2D8E', // purple
  '#C75000', // burnt orange
  '#0097A7', // teal
  '#D4376E', // rose
  '#5C6BC0', // indigo
  '#2E7D32', // green
  '#F4511E', // deep orange
  '#00838F', // dark cyan
  '#8E24AA', // deep purple
  '#AD6200', // amber
] as const;

const hashString = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) % 2147483647;
  }
  return Math.abs(hash);
};

export const getChartColor = (metricName: string | undefined): string => {
  if (!metricName) return CHART_PALETTE[0];
  return CHART_PALETTE[hashString(metricName) % CHART_PALETTE.length];
};
